import { combineReducers } from "redux";
import System from "./slice/system";
import Auth from "./slice/auth";
import ProductListingAPICall from "./slice/ProductListingAPICall";
import ProductListingFilterBoxSelection from "./slice/ProductListingFilterBoxSelection";
import ProductListingFilterApplied from "./slice/ProductListingFilterApplied";
import ProductListingFilterBoxActiveSelection from "./slice/ProductListingFilterBoxActiveSelection";
import ProductListingSettings from "./slice/ProductListingSettings";
import ProductInventory from "./slice/model/ProductInventory";
import ProductPricing from "./slice/model/ProductPricing";
import ProductDetail from "./slice/model/ProductDetail";
import ProductCompare from "./slice/model/ProductCompare";
import Cart from "./slice/model/Cart";
import QuotePopupComponent from "./slice/component/QuotePopup";
import OpenQuote from "./slice/model/OpenQuote";
import QuoteDetail from "./slice/model/QuoteDetail";
import HeaderQuoteDetail from "./slice/model/HeaderQuoteDetail";
import QuoteSearchListingFilterBox from "./slice/QuoteSearchListingFilterBox";
import ProductListing from "./slice/model/ProductListing";
import BOM from "./slice/model/BOM";
import BOMProject from "./slice/model/BOMProject";
import BOMFieldActivated from "./slice/model/BOM/BOMFieldActivated";
import BOMDownloadPopup from "./slice/model/BOM/BOMDownloadPopup";
import BOMExactMatch from "./slice/model/BOM/BOMExactMatch";
import BOMReMatch from "./slice/model/BOMReMatch";
import Alert from "./slice/model/Alert";
import Order from "./slice/model/Order";
import FilterSelection from "./slice/model/FilterSelection";
import OrderHistoryUI from "./slice/model/Order/OrderHistoryUI";
import Forecast from "./slice/model/Forecast";
import Profile from "./slice/model/Profile";
import HomePageContent from "./slice/model/HomePageContent";
import QuoteFilterSelection from "./slice/model/QuoteFilterSelection";
import User from "./slice/model/Admin/User";
import AdminFilter from "./slice/model/Admin/AdminFilter";
import AdminCommon from "./slice/model/Admin/AdminCommon";
import Account from "./slice/model/Admin/Account";
import Reports from "./slice/model/Admin/Reports";
import AdminBom from "./slice/model/Admin/AdminBOM";
import AdminAccountFilter from "./slice/model/Admin/AdminAccountFilter";
import DesignHub from "./slice/model/DesignHub";

export default combineReducers({
    system: System,
    //View
    auth: Auth,
    Cart: Cart,
    ProductListingAPICall: ProductListingAPICall,
    ProductListingSettings: ProductListingSettings,
    ProductListingFilterBoxSelection: ProductListingFilterBoxSelection,
    ProductListingFilterBoxActiveSelection: ProductListingFilterBoxActiveSelection,
    ProductListingFilterApplied: ProductListingFilterApplied,
    QuoteSearchListingFilterBox: QuoteSearchListingFilterBox,
    //Models
    model_ProductInventory: ProductInventory,
    model_ProductListing: ProductListing,
    model_ProductPricing: ProductPricing,
    model_ProductDetail: ProductDetail,
    model_ProductCompare: ProductCompare,
    model_OpenQuote: OpenQuote,
    model_QuoteDetail: QuoteDetail,
    model_HeaderQuoteDetail: HeaderQuoteDetail,
    model_BOM: BOM,
    model_BOM_BOMFieldActivated: BOMFieldActivated,
    model_BOM_BOMDownloadPopup: BOMDownloadPopup,
    model_BOM_BOMExactMatch: BOMExactMatch,
    model_BOMProject: BOMProject,
    model_BOMReMatch: BOMReMatch,
    model_Alert: Alert,
    model_Order: Order,
    model_filter_selection: FilterSelection,
    model_OrderHistory__UI: OrderHistoryUI,
    model_Forecast: Forecast,
    model_Profile: Profile,
    model_HomePageContent: HomePageContent,
    model_quote_filter_selection: QuoteFilterSelection,
    model_Admin: User,
    model_Admin_Common: AdminCommon,
    model_admin_filter: AdminFilter,
    model_Admin_common_filter: AdminAccountFilter,
    model_Admin_Account_list: Account,
    model_Admin_Reports_list: Reports,
    model_Admin_BOMs_list: AdminBom,
    //Component
    component_QuotePopup: QuotePopupComponent,
    model_DesignHub: DesignHub
});
